import i18n from '@/i18n'

const state = {
  lang: i18n.locale,
  isMobileFlag: false,
  cart: [],
  cartDialogFlag: false,
  user: '',
  loading: false
}
export default state
